"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$ = exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$outboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$inboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$ = exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$outboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$inboundSchema = void 0;
exports.getOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurityToJSON = getOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurityToJSON;
exports.getOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurityFromJSON = getOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurityFromJSON;
exports.getOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequestToJSON = getOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequestToJSON;
exports.getOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequestFromJSON = getOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequestFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$inboundSchema = z.object({
    Bearer: z.string().optional(),
    "X-API-KEY": z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "Bearer": "bearer",
        "X-API-KEY": "xApiKey",
    });
});
/** @internal */
exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$outboundSchema = z.object({
    bearer: z.string().optional(),
    xApiKey: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        bearer: "Bearer",
        xApiKey: "X-API-KEY",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$;
(function (GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$) {
    /** @deprecated use `GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$inboundSchema` instead. */
    GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$.inboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$inboundSchema;
    /** @deprecated use `GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$outboundSchema` instead. */
    GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$.outboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$outboundSchema;
})(GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$ || (exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$ = GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$ = {}));
function getOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurityToJSON(getOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity) {
    return JSON.stringify(exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$outboundSchema
        .parse(getOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity));
}
function getOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetSecurity' from JSON`);
}
/** @internal */
exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$inboundSchema = z.object({
    outcode: z.string(),
});
/** @internal */
exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$outboundSchema = z.object({
    outcode: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$;
(function (GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$) {
    /** @deprecated use `GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$inboundSchema` instead. */
    GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$.inboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$inboundSchema;
    /** @deprecated use `GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$outboundSchema` instead. */
    GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$.outboundSchema = exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$outboundSchema;
})(GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$ || (exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$ = GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$ = {}));
function getOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequestToJSON(getOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest) {
    return JSON.stringify(exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$outboundSchema
        .parse(getOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest));
}
function getOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequestFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest$inboundSchema
        .parse(JSON.parse(x)), `Failed to parse 'GetOutcodePostcodeLocationOutcodesOutcodeSectorsGetRequest' from JSON`);
}
//# sourceMappingURL=getoutcodepostcodelocationoutcodesoutcodesectorsget.js.map